import {MOBILE_WIDTH, TABLET_WIDTH} from 'helpers/stableValues';

const mediaQuery = (width) => window.matchMedia(`screen and (max-width: ${width}px)`);

const mobileMediaQuery = mediaQuery(MOBILE_WIDTH);
const tabletMediaQuery = mediaQuery(TABLET_WIDTH);

export {mediaQuery, mobileMediaQuery, tabletMediaQuery};
